var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconoirHomeProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.5C6.477 2.5 2 6.977 2 12.5C2 18.023 6.477 22.5 12 22.5C17.523 22.5 22 18.023 22 12.5C22 6.977 17.523 2.5 12 2.5Z",
    stroke: "#29292E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.27148 18.846C4.27148 18.846 6.50048 16 12.0005 16C17.5005 16 19.7305 18.846 19.7305 18.846M12.0005 12.5C12.7961 12.5 13.5592 12.1839 14.1218 11.6213C14.6844 11.0587 15.0005 10.2956 15.0005 9.5C15.0005 8.70435 14.6844 7.94129 14.1218 7.37868C13.5592 6.81607 12.7961 6.5 12.0005 6.5C11.2048 6.5 10.4418 6.81607 9.87916 7.37868C9.31655 7.94129 9.00048 8.70435 9.00048 9.5C9.00048 10.2956 9.31655 11.0587 9.87916 11.6213C10.4418 12.1839 11.2048 12.5 12.0005 12.5Z",
    stroke: "#29292E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoirHomeProfile);
export default __webpack_public_path__ + "static/media/iconoir_home_profile.1e8bd9017160023b9058dee269fa1e5f.svg";
export { ForwardRef as ReactComponent };